import { api } from './api';

export interface ICalibration {
  _id: string;
  deviceId: string;
  userId: string;
  recivedDate: string;
  // Sample metadata
  soilSampleDateTime: string;
  npkLabTestTime: string;
  sampleSoilMoisture: number;
  // True values from lab
  trueSoilNitrogen: number;
  trueSoilPhosphorus: number;
  trueSoilPotassium: number;
  trueSoilEC: number;
  trueSoilPH: number;
  // Auto-calculated ratios
  soilNitrogenRatio: number;
  soilPhosphorusRatio: number;
  soilPotassiumRatio: number;
  soilEcRatio: number;
  soilPhOffset: number;
  // Matched weather data
  matchedWeatherDataId?: string;
  active: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface CalibrationInput {
  // Sample metadata
  soilSampleDateTime: string;
  npkLabTestTime: string;
  sampleSoilMoisture: number;
  // True values from lab
  trueSoilNitrogen: number;
  trueSoilPhosphorus: number;
  trueSoilPotassium: number;
  trueSoilEC: number;
  trueSoilPH: number;
}

export const calibrationService = {
  async getActiveCalibration(deviceId: string): Promise<ICalibration | null> {
    const response = await api.get(`/calibration/active/${deviceId}`);
    return response.data.data;
  },

  async getDeviceCalibrations(deviceId: string): Promise<ICalibration[]> {
    const response = await api.get(`/calibration/device/${deviceId}`);
    return response.data.data;
  },

  async createCalibration(
    deviceId: string,
    deviceObjectId: string,
    data: CalibrationInput
  ): Promise<ICalibration> {
    const response = await api.post('/calibration', {
      deviceId,
      _deviceId: deviceObjectId,
      ...data,
    });
    return response.data.data;
  },
};
